import { Pipe, PipeTransform } from '@angular/core';
import { VehicleParamsDto } from '@fleet-beat/api';
import moment from 'moment';
import { Moment } from 'moment';
@Pipe({
  name: 'lastParamsSync',
})
export class LatestParamsSyncPipe implements PipeTransform {
  transform(params: VehicleParamsDto[], timezone: string): string {
    if (!params?.length) return 'N/A';
    const datesArr: (string | null)[] = params.map((param: VehicleParamsDto) => {
      return param?.updatedAt;
    });
    const timeArr: number[] = datesArr.filter(Boolean).map((time: string) => {
      return +new Date(time);
    });
    if (!timeArr.length) {
      return 'N/A';
    }
    const maxTime = Math.max(...timeArr);
    const lastSync: Moment = moment(maxTime).tz(timezone);
    const now: Moment = moment.tz(timezone);
    return lastSync.from(now);
  }
}
